var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { removeState, useState } from './state';
import { proxyApi } from './';
import { config } from '../config/constants';
/** 微信用户的性别 */
export var Sex;
(function (Sex) {
    Sex[Sex["Girl"] = 0] = "Girl";
    Sex[Sex["Boy"] = 1] = "Boy";
})(Sex || (Sex = {}));
/** 微信用户的关注状态 */
export var Subscribe;
(function (Subscribe) {
    Subscribe[Subscribe["NotSubscribe"] = 0] = "NotSubscribe";
    Subscribe[Subscribe["Subscribe"] = 1] = "Subscribe";
})(Subscribe || (Subscribe = {}));
/** login的返回code */
export var LoginCode;
(function (LoginCode) {
    LoginCode[LoginCode["Success"] = 200] = "Success";
    /** 订阅号 */
    LoginCode[LoginCode["Subscribe"] = 412] = "Subscribe";
})(LoginCode || (LoginCode = {}));
export const WechatState = Symbol();
/**
 *本地缓存的粉丝信息
 * @export
 */
export function GetWechatUserInfo() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield useState(WechatState, () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const data = yield promisifyCw('info');
            return Object.assign(data, { headimgurl: (_a = data.headimgurl) === null || _a === void 0 ? void 0 : _a.replace('http:', 'https:') });
        }));
    });
}
export const LoginState = Symbol();
/**
 *本地缓存的登录信息
 * @export
 */
export function cwLogin(refresh) {
    return useState(LoginState, () => promisifyCw('login'), refresh);
}
/**
 * 登出
 */
export function cwLogout() {
    return promisifyCw('logout').then(() => {
        removeState(LoginState);
    });
}
/**
 * 将cw接口promise化
 * @template T 返回数据结果
 * @param {string} name
 */
export function promisifyCw(name) {
    return new Promise((resolve, reject) => {
        window.cw(name, resolve, reject);
    });
}
/**
 * 微信的代理接口
 * @description 系统应用市场的微信模块的暴露接口
 * @export
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function wechatApi(target, data) {
    return proxyApi({ module: 'wechat', target, data });
}
/**
 * 查询行为事件
 * @param {({ type: T, uaId?: string } & ListPagination)} params
 */
export function getEventRecords(params) {
    return wechatApi('query_events', Object.assign({ uaId: config.uaId }, params));
}
/**
 * 根据id查询某个行为事件
 * @param {string} id
 */
export function getEventDetail(id) {
    return wechatApi('query_event', { id });
}
/**
 * 以originopenId为主体查询行为事件,可按path过滤
 * @param {({ type: T, uaId?: string ,path?:string} & ListPagination)} params
 */
export function getEventRecordsByKol(params) {
    return wechatApi('query_events_kol', Object.assign({ uaId: config.uaId }, params));
}
/**
 * 获取联系人信息
 * @export
 * @template T
 * @param {T} keys
 */
export function getLeadinfo(keys) {
    return wechatApi('leadinfo', keys !== null && keys !== void 0 ? keys : ['FullName', 'Industry', 'Mailbox', 'Department', 'Organization', 'Phone', 'Position', 'Sex', 'FullAddress']);
}
